module.exports = __webpack_public_path__ + "img/compact.ba030df2.png";